import { Box, FormControl, Input, InputLabel, MenuItem, Select, Stack } from "@mui/material";
import { useState } from "react";
import { checkDoublePattern, checkHoursPattern } from "../../utils/commons";

//Conductividad del agua para tomate (dS/m): "0" es "NO SABE"
const VALORES_CONDUCTIVIDAD_TOMATE = ["0", "0.5", "1.0", "1.5", "2.0", "2.5", "3.0", "3.5", "4.0", "4.5", "5.0"];

const FormAguaRiegoCampañaComponent = ({position, setPosition, state, setState}) => {

    const [errors, setErrors] = useState({});

    const handleNext = (e) => {
        e.preventDefault();
        if(validateForm()){
            setPosition(4);
        }
    };

    const handlePrev = (e) => {
        e.preventDefault();
        setPosition(2);
    }

    const handleChangeLimiteLV = (e) => {
        if(checkHoursPattern(e)){
            setState({...state, limiteLV: e});
        }
    }

    const handleChangeLimiteSD = (e) => {
        if(checkHoursPattern(e)){
            setState({...state, limiteSD: e});
        }
    }

    /*const handleChangeDotacionRiego = (e) => {
        if(checkDoublePattern(e)){
            setState({...state, dotacionRiego: e});
        }
    }*/

    const handleChangeConductividad = (e) => {
        if(checkDoublePattern(e)){
            setState({...state, conductividad: e});
        }
    }

    const validateForm = () =>{

        setErrors({});

        let inputIds = "";
        let valid = true;

        if((state.limiteLV === undefined || state.limiteLV === '') && (state.tipoCultivo === "olivar" || state.tipoCultivo === "citricos")){
            setErrors(errors => ({...errors, errorLimiteLV: true, errorLimiteLVMsg: ""}));
            inputIds = inputIds ? inputIds +",limiteLV" : "limiteLV";
            valid = false;
        }

        if((state.limiteSD === undefined || state.limiteSD === '') && (state.tipoCultivo === "olivar" || state.tipoCultivo === "citricos")){
            setErrors(errors => ({...errors, errorLimiteSD: true, errorLimiteSDMsg: ""}));
            inputIds = inputIds ? inputIds +",limiteSD" : "limiteSD";
            valid = false;
        }

        /*if(state.dotacionRiego === undefined || state.dotacionRiego === ''){
            setErrors(errors => ({...errors, errorDotacionRiego: true, errorDotacionRiegoMsg: ""}));
            inputIds = inputIds ? inputIds +",dotacionRiego" : "dotacionRiego";
            valid = false;
        }else if(!(checkDoublePattern(state.dotacionRiego))){
            setErrors(errors => ({...errors, errorNRamales: true, errorNRamalesMsg: "Debe ser un valor numérico."}));
            inputIds = inputIds ? inputIds +",dotacionRiego" : "dotacionRiego";
            valid = false;
        }*/

        /*if(state.conductividad === undefined || state.conductividad === ''){
            setErrors(errors => ({...errors, errorConductividad: true, errorConductividadMsg: ""}));
            inputIds = inputIds ? inputIds +",conductividad" : "conductividad";
            valid = false;
        }*/

        if(state.tipoCultivo === "tomate" && (state.uniRedRiego === undefined || state.uniRedRiego === '')){
            setErrors(errors => ({...errors, erroruniRedRiego: true, erroruniRedRiegoMsg: "Seleccione la uniformidad (si no se conoce, 95 %)."}));
            inputIds = inputIds ? inputIds +",uniRedRiego" : "uniRedRiego";
            valid = false;
        }

        if(state.tipoCultivo === "tomate" && (state.conductividad === undefined || state.conductividad === null || state.conductividad === '')){
            setErrors(errors => ({...errors, errorConductividad: true, errorConductividadMsg: "Seleccione la conductividad (si no se conoce, NO SABE)."}));
            inputIds = inputIds ? inputIds +",conductividad" : "conductividad";
            valid = false;
        }else if(state.tipoCultivo !== "tomate" && !(checkDoublePattern(state.conductividad))){
            setErrors(errors => ({...errors, errorConductividad: true, errorConductividadMsg: "Debe ser un valor numérico."}));
            inputIds = inputIds ? inputIds +",conductividad" : "conductividad";
            valid = false;
        }

        if(inputIds !== ""){
            try{
                let elem = document.getElementById(inputIds.split(",")[0]);
                elem.scrollIntoView({behavior: "smooth"});
                elem.focus();
            }catch(err){

            }
        }
        return valid;
    }

    return(
        <>
        <Box className={position !== 3 && 'hide'}>
        {((state.tipoCultivo != "tomate") && (state.tipoCultivo != "fresa"))  &&
        <>
            <h2>Límite de horas de Riego por Tarifa</h2>
            <FormControl sx={{width: "100%", marginBottom: "20px"}} variant="standard">
                    <InputLabel htmlFor="limiteLV">Límite horas de riego Lunes - Viernes*</InputLabel>
                    <Input
                        id="limiteLV"
                        className="t4b-finca-sector-inputs"
                        label="Límite Lunes - Viernes"
                        required
                        name="limiteLV"
                        value={state.limiteLV}
                        onChange={(e) => handleChangeLimiteLV(e.target.value)}
                        error={errors.errorLimiteLV}
                    />
                    {errors.errorLimiteLVMsg && <div className="errorInput">{errors.errorLimiteLVMsg}</div>}
            </FormControl>
            <FormControl sx={{width: "100%", marginBottom: "20px"}} variant="standard">
                    <InputLabel htmlFor="limiteSD">Límite horas de riego Sábado - Domingo*</InputLabel>
                    <Input
                        id="limiteSD"
                        className="t4b-finca-sector-inputs"
                        label="Límite Sábado - Domingo"
                        required
                        name="limiteSD"
                        value={state.limiteSD}
                        onChange={(e) => handleChangeLimiteSD(e.target.value)}
                        error={errors.errorLimiteSD}
                    />
                    {errors.errorLimiteSDMsg && <div className="errorInput">{errors.errorLimiteSDMsg}</div>}
            </FormControl>
        </>
        }

            {(state.tipoCultivo === "tomate")  &&
            <FormControl sx={{width: "100%", marginBottom: "20px"}} variant="standard">
                    <InputLabel htmlFor="uniRedRiego">Uniformidad de la red de riego*</InputLabel>
                    {/* Los mismos valores que la tabla del factor de corrección del backend (FactorCUTomate) */}
                    <Select
                        id="uniRedRiego"
                        className="t4b-finca-sector-inputs"
                        label="Uniformidad de la red de riego"
                        required
                        name="uniRedRiego"
                        value={state.uniRedRiego || ""}
                        onChange={(e) => setState({...state, uniRedRiego: e.target.value})}
                        error={errors.erroruniRedRiego}
                    >
                        <MenuItem value="">-</MenuItem>
                        <MenuItem value="75">75 %</MenuItem>
                        <MenuItem value="80">80 %</MenuItem>
                        <MenuItem value="85">85 %</MenuItem>
                        <MenuItem value="90">90 %</MenuItem>
                        <MenuItem value="95">95 % (si no se conoce)</MenuItem>
                        <MenuItem value="100">100 %</MenuItem>
                    </Select>
                    {errors.erroruniRedRiegoMsg && <div className="errorInput">{errors.erroruniRedRiegoMsg}</div>}
            </FormControl>
            }

            
            <h2>Agua de Riego para la Campaña</h2>
            {/*<FormControl sx={{width: "100%", marginBottom: "20px"}} variant="standard">
                    <InputLabel htmlFor="dotacionRiego">Dotación de Agua para Riego de la Campaña*</InputLabel>
                    <Input
                        id="dotacionRiego"
                        className="t4b-finca-sector-inputs"
                        label="Dotación de agua de riego de la Campaña"
                        required
                        name="dotacionRiego"
                        value={state.dotacionRiego}
                        onChange={(e) => handleChangeDotacionRiego(e.target.value)}
                        error={errors.errorDotacionRiego}
                    />
                    {errors.errorDotacionRiegoMsg && <div className="errorInput">{errors.errorDotacionRiegoMsg}</div>}
            </FormControl>*/}
            {(state.tipoCultivo === "tomate") ?
            <FormControl sx={{width: "100%", marginBottom: "20px"}} variant="standard">
                    <InputLabel htmlFor="conductividad">Conductividad eléctrica del agua para riego (dS/m)*</InputLabel>
                    {/* Los mismos valores que la tabla del factor de conductividad del backend (FactorMayoracionCEITomate).
                        "NO SABE" se guarda como 0 (factor 1, sin corrección) y se muestra como "NO SABE" */}
                    <Select
                        id="conductividad"
                        className="t4b-finca-sector-inputs"
                        label="Conductividad eléctrica del agua para riego"
                        required
                        name="conductividad"
                        value={state.conductividad ?? ""}
                        onChange={(e) => setState({...state, conductividad: e.target.value})}
                        error={errors.errorConductividad}
                    >
                        <MenuItem value="">-</MenuItem>
                        {VALORES_CONDUCTIVIDAD_TOMATE.map(v => (
                            <MenuItem key={v} value={v}>{v === "0" ? "NO SABE" : v.replace(".", ",")}</MenuItem>
                        ))}
                    </Select>
                    {errors.errorConductividadMsg && <div className="errorInput">{errors.errorConductividadMsg}</div>}
            </FormControl>
            :
            <FormControl sx={{width: "100%", marginBottom: "20px"}} variant="standard">
                    <InputLabel htmlFor="conductividad">Conductividad eléctrica del agua para riego (dS/m)</InputLabel>
                    <Input
                        id="conductividad"
                        className="t4b-finca-sector-inputs"
                        label="Conductividad eléctrica del agua para riego"
                        name="conductividad"
                        value={state.conductividad}
                        onChange={(e) => handleChangeConductividad(e.target.value)}
                        error={errors.errorConductividad}
                    />
                    {errors.errorConductividadMsg && <div className="errorInput">{errors.errorConductividadMsg}</div>}
            </FormControl>
            }

            <Stack spacing={2} direction="row" justifyContent="space-between" className="tic4bio-sectores-btns">
                <button className="btn white" onClick={(e) => handlePrev(e)}>Anterior</button>
                <button className="btn green" onClick={(e) => handleNext(e)} style={{margin: "16px 0"}}>Siguiente</button>
            </Stack>
        </Box>
            
        </>
    );
}

export default FormAguaRiegoCampañaComponent;